'use client';

import React from 'react';

import { ButtonExperiment } from '@/components/ButtonExperiment';
import { ExtendedLink } from '@/components/ExtendedLink';

type Props = Pick<
  React.ComponentProps<typeof ButtonExperiment>,
  'children' | 'fullWidth' | 'variant' | 'legacyClassName'
> & {
  href?: string;
  onClick?: () => void;
  outline?: boolean;
  className?: string;
};

export function ShopSummaryActionsCta({
  href,
  children,
  onClick,
  outline,
  className,
  variant,
  legacyClassName,
  ...rest
}: Props) {
  const fallbackVariant = outline ? 'secondary' : 'primary';

  const buttonProps = {
    ...rest,
    variant: variant ?? fallbackVariant,
    legacyClassName: legacyClassName ?? className,
  };

  if (href) {
    return (
      <ExtendedLink href={href} onClick={onClick}>
        <ButtonExperiment as="span" {...buttonProps}>
          {children}
        </ButtonExperiment>
      </ExtendedLink>
    );
  }

  return (
    <ButtonExperiment {...buttonProps} disabled>
      {children}
    </ButtonExperiment>
  );
}
